(() => {
  const name = 'subscriptions';

  App.cartPage = App.cartPage || {};
  const subscriptionsModule = App.cartPage[name] || {};

  App.cartPage[name] = (() => {
    const isCartPage = App.settings.pageType === 'CART_PAGE';
    const {
      confirmRemovingProduct,
      ANIMATION_DURATION,
    } = App.cartPage;

    const isSubscriptionOrderRow = (orderRow) => orderRow.isSubscriptionOrderRow === true;

    const deleteSubscriptionOrderRows = (orderUpdateResponse) => {
      const removeProducts = [];
      App.cartPage.orders.forEachProperty((orderRow, rowHash) => {
        if (isSubscriptionOrderRow(orderRow)) {
          removeProducts.push(rowHash);
        }
      });
      App.eventBus.trigger('cart-page:remove-products', {
        removeProducts,
        response: orderUpdateResponse,
        asyncDelete: false,
      });
    };

    const showUnknownNetworkErrorMessage = () => {
      App.ui.popup(null, { type: App.ui.popup.Type.UNKNOWN_SERVER_ERROR });
    };

    const confirmRemovingFromCart = ({
      $deleteButton,
    }) => {
      const message = texts('removeSubscriptionCart@subscriptions.v2');
      confirmRemovingProduct(message, () => {
        $.ajax({ url: '/cart/removeSubscription' })
          .done((resp) => {
            try {
              const { orderUpdateResponse } = JSON.parse(resp);
              deleteSubscriptionOrderRows(orderUpdateResponse);
              if (isCartPage) {
                $deleteButton
                  .closest('.subscription__item')
                  .slideUp(ANIMATION_DURATION, function removeSubscriptionFromCart() {
                    $(this).remove();
                  });
              }
            } catch (err) {
              showUnknownNetworkErrorMessage();
            }
          })
          .fail(showUnknownNetworkErrorMessage);
      });
    };

    return {
      confirmRemovingFromCart,
      deleteSubscriptionOrderRows,
      isSubscriptionOrderRow,
      showUnknownNetworkErrorMessage,
      ...subscriptionsModule,
    };
  })();
})();
